import * as React from 'react';
import { TimeseriesContext } from './TimeseriesContext';

const TimeseriesContextProvider = ({ children, value }) => (
    <TimeseriesContext.Provider value={value}>{children}</TimeseriesContext.Provider>
);

export default TimeseriesContextProvider;
